module.exports = __webpack_public_path__ + "static/media/ggu-resources.ed237243.svg";